import React, { Component } from 'react';
import TableKPI from './TableKPI'
//import { getDataTab } from '../../components/UserFunctions'

class radar extends Component {
    state = {
        data: [{
            name: "Precision",
            value: 56.80
        }, {
            name: "Recall",
            value: 34.56
        }, {
            name: "F1-score",
            value: 18.89
        }]
    }


    render() {
        return (
            <div data-test = 'kpiManagerradarComponent'>
                <TableKPI data={this.state.data} name={"Radar"} />
            </div>
        )
    }

}

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }

export default radar;
